<template>
  <v-sheet
    :id="`${props.target}`"
    :color="props.color_background ? props.color_background : '#FFFFFF'"
    :class="`
      pt-${props.pt ? props.pt : '0'} 
      pb-${props.pb ? props.pb : '0'}`">
    <v-container fluid v-if="props" class="container-padding py-8">
      <v-sheet
        class="rounded-lg pa-6"
        :color="props.color_box ? props.color_box : '#FFFFFF'"
        :style="`border: 1px solid ${
          props.color_border ? props.color_border : '#e0e0e0'
        }`">
        <v-row align="center">
          <v-col
            v-for="(item, index) in items"
            :key="index"
            cols="12"
            sm="4"
            md="4"
            lg="4"
            :style="
              $vuetify.breakpoint.smAndUp && index < items.length - 1
                ? `border-right: 1px solid ${
                    props.color_border ? props.color_border : '#e0e0e0'
                  }`
                : ''
            ">
            <v-row align="center" no-gutters>
              <v-col v-if="item.img" cols="auto" class="pr-4">
                <v-icon
                  v-if="isIcon(item.img)"
                  :size="props.img_width ? props.img_width : 64">
                  {{ item.img }}
                </v-icon>
                <img
                  v-else
                  :src="item.img"
                  :width="`${props.img_width ? props.img_width : 64}px`" />
              </v-col>
              <v-col>
                <h4
                  v-if="item.headline && item.headline[language]"
                  class="mb-1 text-subtitle-1 font-weight-bold"
                  v-html="item.headline[language]"></h4>
                <div
                  v-if="item.text && item.text[language]"
                  class="text-body-2"
                  v-html="item.text[language]"></div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-sheet>

      <!-- Edit dialog -->
      <v-dialog v-if="edit" persistent v-model="edit" fullscreen>
        <v-card>
          <v-card-title class="text-h5 black white--text">
            Edit Component
          </v-card-title>
          <v-card-text class="pt-5">
            <Core
              name="Core"
              :editProps="editProps"
              @emitProps="setPreviewProps"
              @save="save"
              @cancel="cancel" />
            <!-- Preview -->
            <h2 class="my-2 text-h4 black--text">Preview:</h2>
            <CompUspRow
              v-if="previewProps"
              name="CompUspRow"
              :props="previewProps" />
          </v-card-text>
          <v-divider></v-divider>
        </v-card>
      </v-dialog>
    </v-container>
  </v-sheet>
</template>

<script>
import { mapState } from "vuex";
import CompUspRow from "./CompUspRow";
import Core from "../editor/Core.vue";

export default {
  name: "CompUspRow",
  props: ["props", "edit", "index", "componentId"],
  data() {
    return {
      editProps: {},
      previewProps: null,
    };
  },
  watch: {
    edit: function () {
      this.editProps.target = this.props.target ?? "";
      this.editProps.pt = this.props.pt ?? 0;
      this.editProps.pb = this.props.pb ?? 0;

      this.setEditProp("color_background", "color", "#FFFFFF");
      this.setEditProp("color_box", "color", "#FFFFFF");
      this.setEditProp("color_border", "color", "#e0e0e0");
      this.setEditProp("img_width", "number", 64);

      for (const item of [1, 2, 3]) {
        this.setEditProp(`img_href_${item}`, "image", "");
        this.setEditProp(`headline_${item}`, "text", {});
        this.setEditProp(`text_${item}`, "text", {});
      }
    },
  },
  computed: {
    ...mapState({
      language: state => {
        return state.language ?? "de";
      },
    }),
    items: function () {
      const p = this.props ?? {};
      const filled = value => value && value[this.language];
      return [1, 2, 3]
        .map(item => ({
          img: p[`img_href_${item}`],
          headline: p[`headline_${item}`],
          text: p[`text_${item}`],
        }))
        .filter(item => filled(item.headline) || filled(item.text));
    },
  },
  methods: {
    isIcon(value) {
      return String(value).startsWith("mdi-");
    },
    setEditProp(name, type, fallback) {
      this.editProps[name] = {
        type: type,
        name: name,
        value: this.props[name] ?? fallback,
      };
    },
    save(previewProps) {
      this.previewProps = JSON.parse(JSON.stringify(previewProps));
      this.$emit("save", this.previewProps, this.index, this.componentId);
    },
    cancel() {
      this.$emit("cancel");
    },
    setPreviewProps(previewProps) {
      this.previewProps = JSON.parse(JSON.stringify(previewProps));
    },
  },
  components: {
    Core,
    CompUspRow,
  },
};
</script>

<style></style>
